import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Input, Button } from 'antd';

import { FaRedo, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

import useCaptcha from '../data/useCaptcha';

// styled-component
const CaptchaWrapper = styled.div``;
const CaptchaImage = styled.div`
  position: relative;
`;

const ReloadButton = styled(Button)`
  padding-top: 2.5px !important;
  color: #000;
  position: absolute;
  right: 2.5%;
  top: 25%;
`;

const KeyWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: 5%;
  font-size: 32px;
  color: white;
  font-family: 'StoFrutiger-Roman';
`;

const KeyLetter = styled.span`
  margin-left: 12%;
`;

const ChekIcon = styled(FaCheckCircle)`
  color: green;
`;

const FailIcon = styled(FaTimesCircle)`
  color: red;
`;

const Captcha = React.memo(({ setStatus, shouldReset }) => {
  const { keys = [], reload, isEqual } = useCaptcha();
  const [value, setValue] = useState('');
  const [finalValue, setFinalQuery] = useState('');

  const data = useStaticQuery(graphql`
    {
      textura: file(relativePath: { eq: "captcha/textura.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH)
        }
      }
    }
  `);

  const Icon = isEqual(finalValue) ? ChekIcon : FailIcon;

  useEffect(() => {
    setStatus(isEqual(finalValue));
  }, [finalValue]);

  useEffect(() => {
    const timeOutId = setTimeout(() => setFinalQuery(value.trim()), 250);
    return () => clearTimeout(timeOutId);
  }, [value]);

  const verifyInput = (e) => {
    setValue(e.target.value);
  };

  const handleReload = () => {
    setValue('');
    reload();
  };

  const handleClick = (e) => {
    e.preventDefault();
    handleReload();
  };

  useEffect(() => {
    if (shouldReset) {
      handleReload();
    }
  }, [shouldReset]);

  return (
    <CaptchaWrapper>
      <CaptchaImage>
        <GatsbyImage image={data.textura.childImageSharp.gatsbyImageData} alt="textura" />
        <KeyWrapper>
          {keys.map((letter) => (
            <KeyLetter key={letter.id}>{letter.value}</KeyLetter>
          ))}
        </KeyWrapper>
        <ReloadButton
          shape="circle"
          type="primary"
          icon={<FaRedo />}
          size="small"
          onClick={handleClick}
        />
      </CaptchaImage>
      <Input value={value} placeholder="Digite el texto" onChange={verifyInput} suffix={<Icon />} />
    </CaptchaWrapper>
  );
});

Captcha.propTypes = {
  setStatus: PropTypes.func.isRequired,
  shouldReset: PropTypes.bool.isRequired,
};

export default Captcha;
